import { ApiBitMask, ApiBitMaskTypes } from '../../../logger/bitMasks/ApiBitMask';
import { Fetcher } from '../../Fetcher';

import { casinoConfigEndpoint } from './endpoints';
import type { CasinoConfigResponse, CasinoConfigType } from './types';

export interface FetchCasinoConfigParams {
  JSESSIONID: string;
  baseUrl: string;
  language?: string;
}

interface CasinoConfigPayload {
  parsedResponse: CasinoConfigType;
  rawResponse: CasinoConfigResponse;
}

export const fetchCasinoConfig = ({
  JSESSIONID,
  baseUrl,
  language,
}: FetchCasinoConfigParams): Promise<CasinoConfigPayload> => {
  const params: Record<string, string> = {
    JSESSIONID,
  };

  if (language) {
    params.ln = language;
  }

  return Fetcher.fetch<unknown>(`${baseUrl}${casinoConfigEndpoint.url}`, {
    params,
    format: casinoConfigEndpoint.format,
  }).then((result: unknown) => {
    const parsedResponse = casinoConfigEndpoint.parser(result, undefined);

    ApiBitMask.apply(ApiBitMaskTypes.CasinoConfig);
    return { parsedResponse, rawResponse: result as CasinoConfigResponse };
  });
};
